<template>
    <aside id="side-overlay" ref="sideOverlay" class="fs-sm p-4">
        <div class="d-flex justify-content-end">
            <button type="button" class="ms-auto btn btn-sm btn-alt-secondary mb-4" @click="closeSlideOutOverlay()">
                <i class="fa fa-fw fa-times"></i>
            </button>
        </div>
        <div v-if="contents !== null" v-html="contents"></div>
        <span v-else>Loading</span>
    </aside>
</template>

<script>
    import axios from 'axios';
    import { createApp } from "vue";
    import GroupSelect from '@/components/movements/components/GroupSelect.vue';
    import DriverSelect from "@/components/movements/components/DriverSelect.vue";

    export default {
        data() {
            return {
                contents: '',
            }
        },
        methods: {
            // This had to be done via One.layout since the data attributes don't work since upgrading
            closeSlideOutOverlay() {
                One.layout('side_overlay_close');
            },
        },
        mounted() {
            const vm = this;
            window.jQuery('body').on('click', '[data-sidebar]', function (ev) {
                ev.preventDefault();

                const route = window.jQuery(this).data().sidebar;

                if (route.indexOf('http') === 0) {
                    alert('bad sidebar route');
                    return;
                }

                vm.contents = '';

                axios.get(route)
                    .catch((err) => alert(err.response.data.message))
                    .then((response) => vm.contents = response?.data ?? '')
                    .then(() => {
                        vm.contents.length && One.layout('side_overlay_open');

                        const components = {
                            'movements-components-group-select': GroupSelect,
                            'movements-components-driver-select': DriverSelect,
                        };

                        let n = 0;
                        for (const tag in components) {
                            for (const el of document.querySelectorAll(tag)) {
                                const app = createApp({
                                    template: el.outerHTML,
                                    name: `${tag} ${++n}`,
                                });
                                app.component(tag, components[tag]);
                                app.mount(el);
                            }
                        }

                    });
            });
        }
    }
</script>
